module.exports = __webpack_public_path__ + "img/shipOld.96a4628f.png";